
    // IMPORTS
    import { computed, defineComponent, PropType, ref } from 'vue'

    import DownloadInfo from './download-info.vue'

    import { IDocumentDisplayInfo } from '@/types/document'
    import { BlobApi, buildLocalization } from '@/util'

    export default defineComponent({
        name: 'docLink',

        components: {
            DownloadInfo
        },

        props: {
            doc: { type: Object as PropType<IDocumentDisplayInfo>, required: true },
            displayName: { type: String as PropType<string | null>, required: false, default: () => null }
        },

        setup(props) {
            const { localize } = buildLocalization()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const isDownloading = ref<boolean>(false)

            const publicData = { isDownloading }

            /********************************************************************************************************************
             COMPUTED PROPERTIES
             ********************************************************************************************************************/
            const computedDisplayName = computed(() => props.displayName ?? props.doc.localizedDocName)
            const description = computed(() => props.doc.localizedDescription)

            const computedData = { computedDisplayName, description }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            function downloadDoc(blobName: string) {
                const api = new BlobApi

                isDownloading.value = true
                api.downloadAndShowPdf(blobName, localize).finally(() => isDownloading.value = false)
            }

            const publicMethods = { downloadDoc }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
